import axiosInstance from './../providers/Axios';

import { getProfileUser } from '../config/paths';

export const callGetUserProfile = async (wcToken) => {
  const firstPosition = wcToken.indexOf('%');
  const userId = wcToken.substring(0, firstPosition);

  return axiosInstance({
    url: `${getProfileUser}/${userId}`,
    method: 'get',
  });
};

export const updateUserProfile = async (userId, data) => {
  return axiosInstance({
    url: `${getProfileUser}/${userId}`,
    method: 'put',
    data: data,
  });
};
